import { Delete, Edit } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  TableBody,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery
} from '@mui/material';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import BSTableContainer from './components/BSTableContainer';
import BSTableHeaderCell from './components/BSTableHeaderCell';
import BSTableBodyCell from './components/BSTableBodyCell';
import BSTable from './components/BSTable';
import { generateTeamName } from '../../../helpers/teams';
import BSTableRowCollapsible from './components/BSTableRowCollapsible';
import TableScoreControl from '../gameControls/tableScoreControl';
import { Fragment } from 'react';
import ScoringDisplay from '../playerDisplay/scoringDisplay';
import TableScoringDisplay from '../playerDisplay/tableScoringDisplay';
import gameFormatService from '../../../features/gameFormat/gameFormatService';
import { hasWorkspaceAccess, Roles } from '../../../helpers/access';
import { useAuth } from '../../../contexts/authContext';
import PrimaryButton from '../buttons/primaryButton';
import { removeScorer, startGame } from '../../../features/game/gameSlice';
import { useDispatch } from 'react-redux';
import ScoreButton from '../gameControls/scoreButton';

const ScoringTable = ({ games }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const { currentUserProfile, currentUser, currentWorkspace } = useAuth();
  const dispatch = useDispatch();

  const handleStartGame = (game) => {
    dispatch(startGame(game.id))
      .unwrap()
      .then(() => {
        //navigate(`/game/scoring/${game.id}`);
      });
  };

  const handleRemoveScorer = (game) => {
    dispatch(removeScorer({ gameId: game.id }));
  };

  const getSubContent = (game) => {
    const gameScorer = game.scorer?.id || game.scorer;

    switch (game.status) {
      case gameFormatService.GameStatus.NOT_STARTED:
        return (
          <Box
            display={'flex'}
            flexDirection={'row'}
            alignSelf={'center'}
            justifySelf={'center'}
            gap={1}>
            {(hasWorkspaceAccess(currentUserProfile, currentWorkspace, Roles.SCORER) ||
              (currentUser && currentUser.uid === gameScorer)) && (
              <>
                <PrimaryButton
                  variant="contained"
                  color="success"
                  onClick={() => handleStartGame(game)}>
                  Start Game
                </PrimaryButton>
                <Button
                  color="primary"
                  variant="outlined"
                  size="small"
                  onClick={() => handleRemoveScorer(game)}>
                  Unassign
                </Button>
              </>
            )}
          </Box>
        );
      default:
        return (
          <Box
            display={'flex'}
            flexDirection={'row'}
            alignSelf={'center'}
            justifySelf={'center'}
            gap={1}>
            <ScoreButton game={game} />
            <Button
              color="primary"
              variant="outlined"
              size="small"
              onClick={() => handleRemoveScorer(game)}>
              Unassign
            </Button>
          </Box>
        );
      // return <TableScoringDisplay game={game} />;
    }
  };

  return (
    <BSTableContainer>
      <BSTable>
        <TableHead>
          {!isMobile ? (
            <TableRow sx={{ backgroundColor: (theme) => theme.palette.background.paper }}>
              <BSTableHeaderCell></BSTableHeaderCell>
              <BSTableHeaderCell>Rink</BSTableHeaderCell>
              <BSTableHeaderCell>Game</BSTableHeaderCell>
              <BSTableHeaderCell>TeamA</BSTableHeaderCell>
              <BSTableHeaderCell>TeamB</BSTableHeaderCell>
              <BSTableHeaderCell align="right">Actions</BSTableHeaderCell>
            </TableRow>
          ) : (
            <TableRow sx={{ backgroundColor: (theme) => theme.palette.background.paper }}>
              <BSTableHeaderCell></BSTableHeaderCell>
              <BSTableHeaderCell>Rink</BSTableHeaderCell>
              <BSTableHeaderCell>Game</BSTableHeaderCell>
              {/* <BSTableHeaderCell align="right">Actions</BSTableHeaderCell> */}
            </TableRow>
          )}
        </TableHead>
        <TableBody>
          {games.map((game, idx) =>
            !isMobile ? (
              <BSTableRowCollapsible key={game.id} subContent={getSubContent(game)}>
                <BSTableBodyCell>
                  {game.green}
                  {game.rink}
                </BSTableBodyCell>
                <BSTableBodyCell
                  sx={{
                    fontWeight: 500,
                    color: 'text.primary',
                    borderBottom: 'none',
                    cursor: 'pointer',
                    textDecoration: 'underline'
                  }}>
                  {game.name}
                </BSTableBodyCell>
                <BSTableBodyCell>{game.teams.teamA.players[0]}</BSTableBodyCell>
                <BSTableBodyCell>{game.teams.teamB.players[0]}</BSTableBodyCell>
                <BSTableBodyCell>
                  <Box display="flex" justifyContent="flex-end" gap={1}>
                    {game.status === gameFormatService.GameStatus.NOT_STARTED ? (
                      <PrimaryButton
                        variant="contained"
                        color="success"
                        onClick={() => handleStartGame(game)}>
                        Start Game
                      </PrimaryButton>
                    ) : (
                      <ScoreButton game={game} />
                    )}
                    <Button
                      color="primary"
                      variant="outlined"
                      size="small"
                      onClick={() => handleRemoveScorer(game)}>
                      Unassign
                    </Button>
                    {/* <Button color="secondary" variant="outlined" size="small">
                      Edit
                    </Button> */}
                  </Box>
                </BSTableBodyCell>
              </BSTableRowCollapsible>
            ) : (
              <BSTableRowCollapsible key={game.id} subContent={getSubContent(game)}>
                <BSTableBodyCell>
                  {game.green}
                  {game.rink}
                </BSTableBodyCell>
                <BSTableBodyCell
                  sx={{
                    fontWeight: 500,
                    color: 'text.primary',
                    borderBottom: 'none',
                    cursor: 'pointer',
                    textDecoration: 'underline'
                  }}>
                  {game.name}
                </BSTableBodyCell>
                {/* <BSTableBodyCell align="right">
                  <Box display="flex" justifyContent="flex-end" gap={1}>
                    <ScoreButton game={game} />
                    <Button color="primary" variant="outlined" size="small">
                      Unassign
                    </Button>
                    <Button color="secondary" variant="outlined" size="small">
                      Edit
                    </Button>
                  </Box>
                </BSTableBodyCell> */}
              </BSTableRowCollapsible>
            )
          )}
        </TableBody>
      </BSTable>
    </BSTableContainer>
  );
};

export default ScoringTable;
